import { useI18n } from '@change-corgi/core/react/i18n';

type Result = ModelHookResult<{
	title: string;
	description: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();

	const title = translate('fe.pages.open_platform.title');
	const description = translate('fe.pages.open_platform.description');

	return {
		data: {
			title,
			description,
		},
	};
}
